function Event() {

    this.name = 'event';
}

export {Event};
